(function($) {

// JS for Destinations Taxonomy pages only
if ($('.tax-destinations').length) {
	// add villa count to featured themes
	$('.f-theme').each(function(){
		var slug = $(this).attr('theme-slug');
		var count = 0;
		// $('.hv-villa').each(function(){
		// 	if ($(this).data('themes').includes(slug)) {
		// 		count++;
		// 	}
		// });
		$('.listing').each(function(){
			if ($(this).data('themes').includes(slug)) {
				count++;
			}
		});
		$(this).find('.hv-card__main__meta span').html(count+' <span>Villas</span>');
	});
	// clicking explore villas on featured theme switches over tab and filters
	$('.f-theme .hv-btn').on('click',function(){
		var theme = $(this).closest('.f-theme').find('h3').text();
		$('.listing-tabs__tab.normal').eq(0).trigger('click');
		$('.tax-option').each(function(){
			var tax = $(this).find('span').text();
			if (tax == theme) {
				$(this).trigger('click');
			}
		});
	});
}

})( jQuery );  